exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.tier-badge-popover .popover-body {\n  border-top: 1px solid #dbdbdb;\n}\n", ""]);

